import React, { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";

import VuiBox from "components/VuiBox";
import VuiLabel from "components/VuiLabel";
import VuiButtonCustom from "components/VuiButtonCustom";
import VuiTabs from "components/VuiTabs";
import Table from "examples/Tables/Table";

import colors from "assets/theme/base/colors";

import moment from "moment";

const ProprietsComputer = () => {
  return (
    <div
      style={{
        display: "flex",
        // justifyContent: "center",
        width: "100%",
        height: 580,
        color: "#ffffff",
        // backgroundColor: "#505050",
        padding: 15,
        borderColor: "#ffffff",
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 10,
      }}
    >
      <div>Informações do Computador</div>
    </div>
  );
};

const ProprietsMonitor = () => {
  return (
    <div
      style={{
        display: "flex",
        // justifyContent: "center",
        width: "100%",
        height: 580,
        color: "#ffffff",
        // backgroundColor: "#505050",
        padding: 15,
        borderColor: "#ffffff",
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 10,
      }}
    >
      <div>Informações do Monitor</div>
    </div>
  );
};

const ProprietsOther = () => {
  return (
    <div
      style={{
        display: "flex",
        // justifyContent: "center",
        width: "100%",
        height: 580,
        color: "#ffffff",
        // backgroundColor: "#505050",
        padding: 15,
        borderColor: "#ffffff",
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 10,
      }}
    >
      <div>Informações de outros Perifiricos</div>
    </div>
  );
};

export function StationEdit({ item, onClose }) {
  console.log(">>> StationEdit:item", item);

  return (
    <VuiBox
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "50%",
        bgcolor: colors.grey[600],
        border: "1px solid #000",
        boxShadow: 24,
        borderRadius: 2,
        p: 2,
      }}
      onClick={() => {
        onClose;
      }}
    >
      {item && (
        <>
          <VuiLabel
            title={`${item.hostname} - Propriedades`}
            fontWeightTitle={"bold"}
            sizeTitle={16}
          />
          <VuiLabel />

          <Grid container spacing="0px" sx={{ fontSize: 14, color: "#fff" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: 0,
                width: "100%",
                height: 640,
                marginBottom: 15,
                color: "#fff",
              }}
            >
              <VuiTabs
                tabs={[
                  {
                    id: "dados",
                    label: "Computador",
                    content: <ProprietsComputer />,
                  },
                  {
                    id: "permissoes",
                    label: "Monitor",
                    content: <ProprietsMonitor />,
                  },
                  {
                    id: "logs",
                    label: "Outros",
                    content: <ProprietsOther />,
                  },
                ]}
                defaultTab="dados"
              />
            </div>

            <Grid item xs={12} lg={6} xl={9}></Grid>
            <Grid item xs={12} lg={6} xl={3}>
              <VuiButtonCustom
                title="Fechar"
                color="secondary"
                fontWeight="bold"
                icon="close"
                iconSide="left"
                onClick={() => {
                  onClose();
                }}
              />
            </Grid>
          </Grid>
        </>
      )}
    </VuiBox>
  );
}
